import React from 'react'
import { Button, Typography } from '@s4l/ds'

import Image from '../../Atoms/Image'

import styles from './index.module.css'
import { useS4LContext } from '@s4l/react-context'
import { IconTrash } from '@s4l/icons/IconTrash'

interface INoRooms {
  onClickCTA?: () => void
}

function NoRooms({ onClickCTA }: Readonly<INoRooms>) {
  const handleClickCTA = () => {
    onClickCTA?.()
  }

  const { i18n } = useS4LContext()
  return (
    <div className={styles.container} data-testid="no-rooms">
      <Image
        src="https://static.stayforlong.com/web/images/hotel-detail-page/rooms/20251107_2-no-results.svg"
        alt="No rooms"
      />
      <Typography variant="title" size="xs" as="h3">
        {i18n.formatMessage({ id: 'hdp-filters.empty-state-title' })}
      </Typography>
      <Typography variant="body" size="l" as="p">
        {i18n.formatMessage({ id: 'hdp-filters.empty-state-body' })}
      </Typography>
      <Button
        leadingIcon={<IconTrash />}
        variant="outlined-rounded"
        size="small"
        onClick={handleClickCTA}
        data-testid="phone-button"
      >
        {i18n.formatMessage({ id: 'hdp-filters.empty-state-cta' })}
      </Button>
    </div>
  )
}

NoRooms.displayName = 'NoRooms'

export default NoRooms
